import Swiper from "swiper";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind('[data-fancybox="slider-image"]');

const selectors = {
  block: "[data-slider-image]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    spaceBetween: 24,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },
    
    on: {
      init: (swiper) => {
        swiper.el.style.opacity = '1';
      }
    }
  });


const initBlock = (block) => {
  Swiper.use([Navigation, Pagination, FreeMode]);

  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
